/**
 * 直接更新state的多个方法的对象
 */
import {
	SET_USER_NAME
  } from './mutation-types'

export default {
	// 保存user_name
	[SET_USER_NAME](state, userName) {
		state.userName = userName;
	},
}


// WEBPACK FOOTER //
// ./src/store/mutations.js